const state ={
    user:{
        name:"",
        surname:"",
        canEdit: true
    }
}


const getters = {
    clearance:state =>{
        return state.user.canEdit;
    }
}

export default {
    state,
    getters
}